module.exports = __webpack_public_path__ + "img/Blue-file-empty.1ff25c8d.png";